import React, { useEffect, useRef, useState } from "react";

// Smoothly animates a number from `from` up to `value` (easeOutCubic).
// Used for the standings scores so totals tick up after each round.
export const CountUp = ({ value, from = null, duration = 900, className, ...rest }) => {
  const initial = from != null ? from : value;
  const [display, setDisplay] = useState(initial);
  const displayRef = useRef(initial);
  const rafRef = useRef(null);

  useEffect(() => {
    const startVal = displayRef.current;
    const endVal = value;
    if (startVal === endVal) {
      setDisplay(endVal);
      return;
    }
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      const cur = Math.round(startVal + (endVal - startVal) * eased);
      displayRef.current = cur;
      setDisplay(cur);
      if (t < 1) rafRef.current = requestAnimationFrame(step);
      else displayRef.current = endVal;
    };
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, duration]);

  return (
    <span className={className} {...rest}>
      {display}
    </span>
  );
};
